module.exports = __webpack_public_path__ + "img/logo-ibotech-white.164a4969.png";